export const getAdvanceSearchAlert = state => state.showAdvanceSearchAlert

export const isLogin = state => {
  return state.isLogin
}

export const getUserInfo = (state) => {
  return JSON.parse(sessionStorage.userInfo)
}

// export const getProductIndexAppAreas = (state) => {
//   if(state.productIndexDatas && state.productIndexDatas.bevolApplicationAreas.length > 0) {
//     return state.productIndexDatas.bevolApplicationAreas.filter(item => {
//       item.pid2 == 0
//     })
//   }
// }



// WEBPACK FOOTER //
// ./src/store/getters.js